import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { Router } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { requiredTrim } from '../../../../shared/validators/string-trim.validator';
import { ConfiguracaoService } from '../../../../shared/services/apis/scanntech/configuracao.service';
import { ConfiguracaoResponse } from '../../../../shared/services/responses/scanntech/configuracao.response';
import { ConfiguracaoRequest } from '../../../../shared/services/requests/scanntech/configuracao.request';
import { ReturnStruct } from '../../../../shared/services/structs/return.struct';
import { HeaderComponent } from '../../../../shared/components/header/header.component';

@Component({
  selector: 'app-configurar-resulth-scanntech',
  standalone: true,
  imports: [
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    HeaderComponent,
  ],
  templateUrl: './configurar-resulth-scanntech.component.html',
  styleUrl: './configurar-resulth-scanntech.component.css',
})
export class ConfigurarResulthScanntechComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private configuracaoService: ConfiguracaoService,
    private alertService: AlertService,
    private router: Router
  ) {
    this.moduloEnum = ModuloEnum.Integracao;
    this.funcionalidadeEnum = FuncionalidadeEnum.Integracao_ResulthScanntech;
  }

  public model: FormGroup;
  public _isLoadingButtonSalvar: boolean = false;
  public _configuracaoResponse: ConfiguracaoResponse;
  public buttonDesativado: boolean = false;
  public idConfiguracao: number;
  public novaUrl: string = '';
  // Colocar uma lista padrão de prod futuramente
  public listaUrl: string[] = ['http://br.homo.apipdv.scanntech.com'];

  async ngOnInit(): Promise<void> {
    this.model = this.formBuilder.group({
      ativo: new FormControl(true, [Validators.required, requiredTrim]),
      idEmpresa: new FormControl('', [Validators.required, requiredTrim]),
      idLocal: new FormControl('', [Validators.required, requiredTrim]),
      usuario: new FormControl('', [Validators.required, requiredTrim]),
      senha: new FormControl('', [Validators.required, requiredTrim]),
    });

    await this.popularDadosConfig();
  }

  popularDadosConfig(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.configuracaoService.get().subscribe({
        next: (configuracaoResponse: ConfiguracaoResponse) => {
          if (configuracaoResponse.isError) {
            this.alertService.show('Erro', configuracaoResponse.errorDescription, AlertType.error);
            return;
          }
          this.idConfiguracao = configuracaoResponse.configuracao.idConfiguracao;
          this.model.get('ativo')?.setValue(configuracaoResponse.configuracao.ativo);
          this.model.get('idEmpresa')?.setValue(configuracaoResponse.configuracao.idEmpresaScanntech);
          this.model.get('idLocal')?.setValue(configuracaoResponse.configuracao.idLocal);
          this.model.get('usuario')?.setValue(configuracaoResponse.configuracao.usuario);
          this.model.get('senha')?.setValue(configuracaoResponse.configuracao.senha);
          this.listaUrl = configuracaoResponse.listaUrl || [];
          this._configuracaoResponse = configuracaoResponse;
          resolve();
        },
        error: (error: any) => {
          this.alertService.show('Erro inesperado', error, AlertType.error);
          reject();
        },
      });
    });
  }

  submit(): void {
    if (this._isLoadingButtonSalvar || this.model.invalid) {
      return;
    }

    const configuracaoRequest: ConfiguracaoRequest = {
      ativo: this.model.get('ativo')?.value,
      idEmpresa: this.model.get('idEmpresa')?.value,
      idLocal: this.model.get('idLocal')?.value,
      senha: this.model.get('senha')?.value?.trim(),
      usuario: this.model.get('usuario')?.value?.trim(),
      listaUrl: this.listaUrl,
    };

    if (!this.idConfiguracao) {
      this.novaConfiguracao(configuracaoRequest);
    } else {
      this.atualizarConfiguracao(configuracaoRequest);
    }
  }

  private atualizarConfiguracao(configuracaoRequest: ConfiguracaoRequest): void {
    this._isLoadingButtonSalvar = true;
    this.buttonDesativado = true;

    this.configuracaoService.put(this.idConfiguracao, configuracaoRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoadingButtonSalvar = false;
        this.buttonDesativado = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Configuração salva com sucesso.', AlertType.success);
        this.router.navigate(['/integracao/resulth-scanntech']);
      },
      error: (error: any) => {
        this._isLoadingButtonSalvar = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  private novaConfiguracao(configuracaoRequest: ConfiguracaoRequest): void {
    this._isLoadingButtonSalvar = true;
    this.buttonDesativado = true;

    this.configuracaoService.post(configuracaoRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoadingButtonSalvar = false;
        this.buttonDesativado = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Configuração salva com sucesso.', AlertType.success);
        this.router.navigate(['/integracao/resulth-scanntech']);
      },
      error: (error: any) => {
        this._isLoadingButtonSalvar = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  somenteNumeros(event: any): void {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/\D/g, '');
    event.target.value = inputValue;
  }

  adicionarUrl(): void {
    if (!this.listaUrl.includes(this.novaUrl)) {
      this.listaUrl.push(this.novaUrl);
      this.novaUrl = '';
    } else {
      this.alertService.show('Aviso', 'Esta URL já foi adicionada à lista.', AlertType.warning);
    }
  }

  removerUrl(index: number): void {
    if (index >= 0 && index < this.listaUrl.length) {
      this.listaUrl.splice(index, 1);
    }
  }
}
